import { render } from "./StoresEditColumnsModal.vue?vue&type=template&id=63b8bbc6"
import script from "./StoresEditColumnsModal.vue?vue&type=script&lang=js"
export * from "./StoresEditColumnsModal.vue?vue&type=script&lang=js"

import "./StoresEditColumnsModal.vue?vue&type=style&index=0&id=63b8bbc6&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__